export default "__VITE_ASSET__DIe$FBwm__"